import { render, staticRenderFns } from "./DataPackModal.vue?vue&type=template&id=2267c406&scoped=true"
import script from "./DataPackModal.vue?vue&type=script&lang=js"
export * from "./DataPackModal.vue?vue&type=script&lang=js"
import style0 from "./DataPackModal.vue?vue&type=style&index=0&id=2267c406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267c406",
  null
  
)

export default component.exports